module.exports = __webpack_public_path__ + "52f690ad882c4ad90c9b544d79892954.png";